var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-tooltip',{attrs:{"effect":"dark","content":_vm.text || '',"placement":"top-start","disabled":!_setup.isOverflow,"popper-class":"ellipsis-two-line-tooltip-popper"}},[_c('span',{ref:"contentRef",staticClass:"ellipsis-two-line-tooltip"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }